import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { cn } from '~/shadcn/lib/utils'

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      richColors
      className="toaster group"
      position="top-center"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--color-popover)',
          '--normal-text': 'var(--color-primary)',
          '--normal-border': 'var(--color-border)',
          '--border-radius': 'var(--color-radius)',
        } as React.CSSProperties
      }
      {...props}
      toastOptions={{
        ...props.toastOptions,
        classNames: {
          ...props.toastOptions?.classNames,
          toast: cn('group', props.toastOptions?.classNames?.toast),
          title: cn('!text-[16px]', props.toastOptions?.classNames?.title),
          actionButton: cn(
            'group-data-[type=success]:!bg-[var(--success-text)] group-data-[type=success]:!text-[var(--success-bg)]',
            'group-data-[type=warning]:!bg-[var(--warning-text)] group-data-[type=warning]:!text-[var(--warning-bg)]',
            'group-data-[type=error]:!bg-[var(--error-text)] group-data-[type=error]:!text-[var(--error-bg)]',
            'group-data-[type=info]:!bg-[var(--info-text)] group-data-[type=info]:!text-[var(--info-bg)]',
            props.toastOptions?.classNames?.actionButton
          ),
        },
      }}
    />
  )
}

export { Toaster }
